import { makeStyles } from "@mui/styles";
import { Theme } from "@mui/material/styles/createTheme";

export const useStyles = makeStyles((theme: Theme) => ({
    modalHeader: {
        display: "flex",
        alignItems: "center",
        padding: "16px 24px",
        borderBottom: `1px solid ${theme.palette.border.select}`,
        fontSize: "18px",
        fontWeight: 400,
        fontFamily: "Open Sans",
        color: theme.palette.info.main,
    },
    modalBody: {
        padding: "0 24px 24px 24px",
        display: "flex",
        flexDirection: "column",
    },
    footer: {
        borderTop: `1px solid ${theme.palette.border.select}`,
        display: "flex",
        padding: "16px 24px",
        gap: "16px",
        justifyContent: "flex-end",
    },
    submitButton: {
        "&.MuiButton-root": {
            fontFamily: "Open Sans !important",
            fontSize: "12px !important",
            fontWeight: "700 !important",
        },
    },
    tabs: {
        padding: "0px 0px 24px 0px ",
        "&.MuiTabs-root .MuiTabs-scroller .MuiTabs-indicator": {
            borderBottom: "none",
            backgroundColor: "transparent",
        },
        "&.MuiTabs-root .MuiTabs-scroller .MuiTabs-flexContainer .MuiButtonBase-root": {
            fontFamily: "Open Sans",
            fontWeight: 400,
            fontSize: "14px",
            color: theme.palette.corporateBO.tabText,
            textTransform: "none",
            padding: 0,
            minWidth: 0,
        },
        "&.MuiTabs-root .MuiTabs-scroller .MuiTabs-flexContainer .Mui-selected": {
            fontFamily: "Open Sans",
            fontWeight: 600,
            fontSize: "14px",
            color: theme.palette.corporateBO.tabText,
            textTransform: "none",
            borderBottom: `3px solid ${theme.palette.border.tabs}`,
        },
        "&.MuiTabs-root .MuiTabs-scroller .MuiTabs-flexContainer": {
            gap: theme.spacing(6),
        },
    },
    container: {
        paddingTop: "0 !important",
    },
    divider: {
        height: "1px",
        width: "95%",
        marginLeft: "8px !important",
    },
    switchLabel: {
        "& .MuiFormControlLabel-label": {
            flexGrow: 1,
        },
        "&.MuiFormControlLabel-root": {
            padding: "10px 0",
            width: "230px",
            justifyContent: "flex-end",
            margin: 0,
        },
        "&.MuiFormControlLabel-root .MuiTypography-root": {
            fontFamily: "Open Sans",
            fontWeight: 400,
            fontSize: "14px",
            color: theme.palette.text.secondary,
        },
    },
    switch: {
        "&.MuiSwitch-root .MuiButtonBase-root .MuiSwitch-thumb": {
            background: theme.palette.primary.dark,
        },
        "&.MuiSwitch-root .Mui-checked .MuiSwitch-thumb": {
            background: theme.palette.info.main,
        },
        "&.MuiSwitch-root .MuiSwitch-track": {
            background: theme.palette.corporateBO.checkboxTrack,
        },
        "&.MuiSwitch-root .Mui-checked+ .MuiSwitch-track": {
            background: theme.palette.corporateBO.checkboxTrackChecked,
        },
    },
    text: {
        padding: "24px",
        "&.MuiTypography-root": {
            fontFamily: "Open Sans",
            textAlign: "left",
            fontWeight: 400,
            fontSize: "14px",
            color: theme.palette.text.secondary,
        },
    },
}));

export const modalStyles = {
    position: "absolute" as "absolute",
    top: "50%",
    left: "50%",
    transform: "translate(-50%, -50%)",
    width: "792px",
    maxHeight: "calc(100vh - 32px)",
    overflowY: "auto",
    bgcolor: "background.paper",
    borderRadius: "4px",
};
